import { createTheme } from "@mui/material/styles";

export const THEME = createTheme({
  typography: {
    fontFamily: `iranSansCustom ,sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
